<template>
  <el-form-item :label-width="itemRender.width" :label="itemRender.label"
    :required="itemRender.required ? true : false">
    <el-select disabled v-model="itemRender.value" style="width: 100%" :placeholder="itemRender.placeholder || '请选择'"
      @change="Change">
      <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { searchCapitalUser } from "@/request/api";
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      options: [],
    };
  },
  methods: {

    // 获取数据
    getOptions() {
      this.itemRender.propOptions = [];
      searchCapitalUser().then((res) => {
        if (res.code == 200) {
          this.options = res.data;
        }

      })
    },
    Change(e) {
      console.log(e);
    }
  },
  mounted() {
    this.getOptions();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .el-radio {
    margin-bottom: 12px;
  }
}

.vacate {
  .vacate-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid #dfe2e8;

    ::v-deep .el-input__inner {
      border: 0;
    }

    span {
      width: 100px;
    }
  }
}

.el-form-item {
  position: relative;

  .phone {
    position: absolute;
    right: 10px;
    top: 0px;
  }

  .phoneNumber {
    display: flex;
    align-items: center;
    border: 1px solid #dfe2e8;
    padding: 0 8px;

    ::v-deep .el-input__inner {
      border: 0;
    }

    span {
      padding-right: 8px;
      border-right: 1px solid #dfe2e8;
    }
  }

  .enclosure {
    display: flex;
    align-items: center;
    color: #999999;

    i {
      color: #5794f6;
      font-size: 18px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
}

.money {
  .div {
    margin-top: 12px;
  }
}
</style>
